import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider } from "@/context/AppContext";
import MobileShell from "@/components/MobileShell";
import HomePage from "@/pages/Home";
import ServicesPage from "@/pages/Services";
import ServiceDetailPage from "@/pages/ServiceDetail";
import RequestPage from "@/pages/RequestPage";
import RequestsPage from "@/pages/Requests";
import PaymentsPage from "@/pages/Payments";
import SupportPage from "@/pages/Support";
import ProfilePage from "@/pages/Profile";
import ArchitecturePage from "@/pages/Architecture";
import AdminLogin from "@/pages/admin/AdminLogin";
import PortalLayout from "@/pages/admin/PortalLayout";
import PortalDashboard from "@/pages/admin/PortalDashboard";
import PortalUsers from "@/pages/admin/PortalUsers";
import PortalData from "@/pages/admin/PortalData";
import PortalIntegrations from "@/pages/admin/PortalIntegrations";
import PortalAudit from "@/pages/admin/PortalAudit";
import PortalSecurity from "@/pages/admin/PortalSecurity";
import PortalGovernance from "@/pages/admin/PortalGovernance";

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<MobileShell />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/services/:id" element={<ServiceDetailPage />} />
            <Route path="/requests" element={<RequestsPage />} />
            <Route path="/requests/:ref" element={<RequestPage />} />
            <Route path="/payments" element={<PaymentsPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/architecture" element={<ArchitecturePage />} />
          </Route>
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/portal" element={<PortalLayout />}>
            <Route index element={<PortalDashboard />} />
            <Route path="dashboard" element={<PortalDashboard />} />
            <Route path="admin" element={<PortalUsers />} />
            <Route path="users" element={<PortalUsers />} />
            <Route path="data" element={<PortalData />} />
            <Route path="integrations" element={<PortalIntegrations />} />
            <Route path="audit" element={<PortalAudit />} />
            <Route path="security" element={<PortalSecurity />} />
            <Route path="governance" element={<PortalGovernance />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AppProvider>
  );
}
